// extracted by mini-css-extract-plugin
var _1 = "ExternalBrandLogo-module__inline--_7kS7";
export { _1 as "inline" }
